import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ArrowLeft, Store } from 'lucide-react';
import { getMerchants } from '../lib/salinguntungApi';

const DEFAULT_CENTER = [-6.2088, 106.8456]; // Jakarta fallback

const FALLBACK_PIN_SVG = `
  <svg width="40" height="48" viewBox="0 0 40 48" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 0C9 0 0 9 0 20c0 14.5 20 28 20 28s20-13.5 20-28C40 9 31 0 20 0z" fill="#2D9CDB"/>
    <circle cx="20" cy="19" r="9" fill="white"/>
  </svg>
`;

const buildMerchantIcon = (merchant) => {
  const logo = merchant.logo;

  if (logo) {
    return L.divIcon({
      className: 'merchant-marker',
      html: `
        <div style="
          width:40px;height:40px;border-radius:50% 50% 50% 0;
          transform:rotate(-45deg);
          background:#2D9CDB;
          box-shadow:0 2px 6px rgba(0,0,0,0.35);
          display:flex;align-items:center;justify-content:center;
          border:2px solid white;
        ">
          <img src="${logo}" style="
            width:28px;height:28px;border-radius:50%;object-fit:cover;
            transform:rotate(45deg);
          " />
        </div>
      `,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40],
    });
  }

  return L.divIcon({
    className: 'merchant-marker',
    html: FALLBACK_PIN_SVG,
    iconSize: [40, 48],
    iconAnchor: [20, 48],
    popupAnchor: [0, -46],
  });
};

const MerchantsMapPage = () => {
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMerchants({ row: 500 })
      .then((data) => setMerchants(data?.data || []))
      .catch(() => setMerchants([]))
      .finally(() => setLoading(false));
  }, []);

  const points = merchants.filter(
    (m) => m.latitude != null && m.longitude != null
  );

  const center = points.length
    ? [Number(points[0].latitude), Number(points[0].longitude)]
    : DEFAULT_CENTER;

  return (
    <div className="relative w-screen h-screen overflow-hidden">
      <Link
        to="/merchants"
        className="absolute top-4 left-4 z-[1000] flex items-center gap-2 bg-white shadow-lg rounded-full px-4 py-2 text-sm font-medium text-slate-700 hover:text-[#2D9CDB] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Kembali
      </Link>

      {loading ? (
        <div className="w-full h-full flex items-center justify-center bg-slate-100">
          <p className="text-slate-500">Memuat peta...</p>
        </div>
      ) : (
        <MapContainer center={center} zoom={12} className="w-full h-full" scrollWheelZoom zoomControl={false}>
          <ZoomControl position="topright" />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {points.map((merchant) => (
            <Marker
              key={merchant.id}
              position={[Number(merchant.latitude), Number(merchant.longitude)]}
              icon={buildMerchantIcon(merchant)}
            >
              <Popup>
                <div className="flex flex-col gap-1 min-w-[160px]">
                  {(merchant.banner || merchant.logo) && (
                    <img
                      src={merchant.banner || merchant.logo}
                      alt={merchant.name}
                      className="w-full h-20 object-cover rounded mb-1"
                    />
                  )}
                  <span className="font-semibold text-sm flex items-center gap-1">
                    <Store className="h-3.5 w-3.5" />
                    {merchant.name}
                  </span>
                  {merchant.address && (
                    <span className="text-xs text-slate-500">{merchant.address}</span>
                  )}
                  <Link
                    to={`/merchants/${merchant.code}`}
                    className="text-xs text-[#2D9CDB] font-medium mt-1"
                  >
                    Lihat detail &rarr;
                  </Link>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      )}
    </div>
  );
};

export default MerchantsMapPage;
